//海洋信息
// const seaCategory = ["政策法规", "行业应用", "理论", "人才培养"]
const seaCategory = ["网络舆情分析", "军事情报分析", "军事情报态势"]
//电磁空间
const electricCategory = ["理论", "人才培养"]
//通用
const commonCategory = ["技术", "产品"]
export default {
    seaCategory,
    electricCategory,
    commonCategory
}